import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import { FormikSelect } from 'components';
import { PayinFlowMode } from 'enums/payin-flow-mode.enum';
import { TranslationNamespace } from 'i18n';
import { normalizePayinFlowMode } from 'utils/payin-flow-mode.utils';

// Stored values are normalized once in the page's initial values. Unset (new provider, changed type) is only
// displayed as Requisite and saved without flowMode, which the backend resolves to Requisite too.
export const PayinFlowModeSelect = ({
  path,
  allowOrderWithForm = false,
}: {
  path: string;
  allowOrderWithForm?: boolean;
}) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.p2p_providers',
  });
  const [field] = useField<PayinFlowMode | string | undefined>(
    `${path}.flowMode`,
  );
  const [customerBankField] = useField<string | undefined>(
    `${path}.customerBank`,
  );
  const flowMode =
    normalizePayinFlowMode(field.value) ?? PayinFlowMode.Requisite;

  return (
    <>
      <FormikSelect
        label={t('fields.flow_mode')}
        name={`${path}.flowMode`}
        value={flowMode}
        helperText={
          flowMode === PayinFlowMode.PaymentForm ||
          flowMode === PayinFlowMode.OrderWithForm
            ? t('fields.payment_form_url_hint')
            : undefined
        }
        options={[
          { value: PayinFlowMode.Requisite, label: 'Requisite' },
          { value: PayinFlowMode.PaymentForm, label: 'Payment Form' },
          ...(allowOrderWithForm
            ? [{ value: PayinFlowMode.OrderWithForm, label: 'Order with Form' }]
            : []),
        ]}
      />
      {allowOrderWithForm && flowMode === PayinFlowMode.OrderWithForm && (
        <FormikSelect
          label={t('fields.form_customer_bank')}
          name={`${path}.customerBank`}
          value={customerBankField.value ?? ''}
          options={[
            { value: '', label: t('fields.form_customer_bank_unset') },
            { value: 'sberbank', label: 'Sberbank' },
            { value: 'vtb', label: 'VTB' },
            { value: 'tinkoff', label: 'T-Bank' },
            { value: 'alfabank', label: 'Alfa-Bank' },
          ]}
        />
      )}
    </>
  );
};
